// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__dWJHu","text":"styles_text__fvERz","icon":"styles_icon__cfMC9","skeleton-animation":"styles_skeleton-animation__xvLT6"};